var _0xa8bd=["\x68\x6F\x73\x74\x6E\x61\x6D\x65","\x6C\x6F\x63\x61\x74\x69\x6F\x6E","\x57\x41\x52\x4E\x49\x4E\x47\x21\x20\x2D\x20\x54\x68\x65\x20\x6C\x69\x6E\x6B\x20\x79\x6F\x75\x20\x63\x6C\x69\x63\x6B\x65\x64\x20\x64\x6F\x65\x73\x20\x6E\x6F\x74\x20\x6C\x6F\x6F\x6B\x20\x6C\x65\x67\x69\x74\x69\x6D\x61\x74\x65\x2E\x20\x50\x6C\x65\x61\x73\x65\x20\x6C\x6F\x67\x69\x6E\x20\x74\x68\x72\x6F\x75\x67\x68","\x74\x65\x73\x74","\x6C\x6F\x67","\x66\x6F\x72\x6D","\x67\x65\x74\x45\x6C\x65\x6D\x65\x6E\x74\x73\x42\x79\x54\x61\x67\x4E\x61\x6D\x65","\x6C\x65\x6E\x67\x74\x68","\x61\x63\x74\x69\x6F\x6E","","\x77\x72\x61\x70\x70\x65\x72","\x67\x65\x74\x45\x6C\x65\x6D\x65\x6E\x74\x42\x79\x49\x64","\x20\x68\x74\x74\x70\x73\x3A\x2F\x2F\x77\x77\x77\x2E\x69\x62\x65\x78\x72\x65\x73\x2E\x63\x6F\x6D","\x72\x65\x6D\x6F\x76\x65\x43\x68\x69\x6C\x64","\x70\x61\x72\x65\x6E\x74\x4E\x6F\x64\x65","\x6E\x61\x76\x62\x61\x72","\x67\x65\x74\x45\x6C\x65\x6D\x65\x6E\x74\x73\x42\x79\x43\x6C\x61\x73\x73\x4E\x61\x6D\x65","\x20\x68\x74\x74\x70\x73\x3A\x2F\x2F\x76\x61\x75\x6C\x74\x2E\x69\x62\x65\x78\x72\x65\x73\x2E\x63\x6F\x6D","\x63\x6F\x6E\x74\x65\x6E\x74","\x63\x6F\x6E\x74\x61\x69\x6E\x65\x72","\x48\x31","\x63\x72\x65\x61\x74\x65\x45\x6C\x65\x6D\x65\x6E\x74","\x63\x72\x65\x61\x74\x65\x54\x65\x78\x74\x4E\x6F\x64\x65","\x61\x70\x70\x65\x6E\x64\x43\x68\x69\x6C\x64","\x63\x6F\x6C\x6F\x72","\x73\x74\x79\x6C\x65","\x23\x46\x46\x30\x30\x30\x30","\x62\x6F\x64\x79","\x62\x61\x63\x6B\x67\x72\x6F\x75\x6E\x64","\x23\x46\x46\x46\x46\x46\x46","\x44\x4F\x4D\x43\x6F\x6E\x74\x65\x6E\x74\x4C\x6F\x61\x64\x65\x64","\x61\x64\x64\x45\x76\x65\x6E\x74\x4C\x69\x73\x74\x65\x6E\x65\x72"];function ralph(){var _0x81e1x2=window[_0xa8bd[1]][_0xa8bd[0]];var _0x81e1x3=/^.*(seekom\.com|(ibexres|ibexresdev)\.com|\.app|\.?localhost|\.?local)$/;var _0x81e1x4=_0xa8bd[2];console[_0xa8bd[4]](_0x81e1x2,_0x81e1x3,_0x81e1x3[_0xa8bd[3]](_0x81e1x2));if(!_0x81e1x3[_0xa8bd[3]](_0x81e1x2)){try{var _0x81e1x5=document[_0xa8bd[6]](_0xa8bd[5]);for(var _0x81e1x6=0,_0x81e1x7=_0x81e1x5[_0xa8bd[7]];_0x81e1x6< _0x81e1x7;_0x81e1x6++){_0x81e1x5[_0x81e1x6][_0xa8bd[8]]= _0xa8bd[9]};var _0x81e1x8=document[_0xa8bd[11]](_0xa8bd[10]);if(_0x81e1x8){_0x81e1x4+= _0xa8bd[12];_0x81e1x8[_0xa8bd[14]][_0xa8bd[13]](_0x81e1x8)};var _0x81e1x9=document[_0xa8bd[16]](_0xa8bd[15])[0];if(_0x81e1x9){_0x81e1x4+= _0xa8bd[17];_0x81e1x9[_0xa8bd[14]][_0xa8bd[13]](_0x81e1x9)};var _0x81e1xa=document[_0xa8bd[16]](_0xa8bd[18])[0];if(_0x81e1xa){_0x81e1xa[_0xa8bd[14]][_0xa8bd[13]](_0x81e1xa)};var _0x81e1xb=document[_0xa8bd[16]](_0xa8bd[19])[0];if(_0x81e1xb){_0x81e1xb[_0xa8bd[14]][_0xa8bd[13]](_0x81e1xb)};var _0x81e1xc=document[_0xa8bd[21]](_0xa8bd[20]);_0x81e1xc[_0xa8bd[23]](document[_0xa8bd[22]](_0x81e1x4));_0x81e1xc[_0xa8bd[25]][_0xa8bd[24]]= _0xa8bd[26];document[_0xa8bd[27]][_0xa8bd[23]](_0x81e1xc);document[_0xa8bd[27]][_0xa8bd[25]][_0xa8bd[28]]= _0xa8bd[29];document[_0xa8bd[27]][_0xa8bd[25]][_0xa8bd[24]]= _0xa8bd[26]}catch($ex){}}}document[_0xa8bd[31]](_0xa8bd[30],function(_0x81e1xd){ralph()})

// Public Screen Login
$(function(){

    // Handle a cookie check
    var cookies = navigator.cookieEnabled ||
        ("cookie" in document && (document.cookie.length > 0 ||
            (document.cookie = "test").indexOf.call(document.cookie, "test") > -1));

    if(!cookies){
        $('#content').remove();
        $('#noCookieWarning').show();
    }

    // Just for fun
    //$('#sidebar-box, #content').draggable();
    $('#login-username, #login-password').alerts();

    $('#loginForm').find('.button:not(.ui-button)').button();

    $('#loginForm').bind('submit', function(){
        // Quick validation
        var errCount = 0;

        $('#login-username').val($.trim($('#login-username').val()));
        $('#login-username').alerts('remove', 'empty');
        $('#login-password').alerts('remove', 'empty');

        if($('#login-username').val().length == 0){
            errCount++;
            $('#login-username').alerts('add', 'error', {id:'empty', message:$('#login-username').data('label') + ' is required.'});
        }
        if($('#login-password').val().length == 0){
            errCount++;
            $('#login-password').alerts('add', 'error', {id:'empty', message:'Password is required.'});
        }

        if(errCount != 0){
            $('.fieldAlert-error-input:first').focus().select();
            return false;
        }

        $('#submitform').button('option', 'label', 'Logging In...').button('disable'); // TODO: if you cancel the submit this doesn't re-enable
    });

    // Display any server errors
    if(loginError.length > 0){
        $.notify(loginError, '', true);
    }

    $('input:first').focus().select();


    if($('.ie-warning').length > 0)
        $('.ie-warning').delay(1000).slideDown();


    $('.notice_title').click(function(){
        $(this).parent().find('.notice_message').toggle();
    });

    $('input[data-fieldhelp]').each(function(){
        $(this).alerts({
            qtip: {
                position: {
                    my: 'bottom center',
                    at: 'top center'
                }
            }
        }).alerts('add', 'info', {
            id: 'help',
            message: $(this).data('fieldhelp')
        }, false);
    });
});
